export const MACRO_ACTION_TYPES = [
  {
    key: 'assign_team',
    label: 'Atribuir equipe',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent',
    label: 'Atribuir atendente',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'Adicionar marcador',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'Remover marcador',
    inputType: 'multi_select',
  },
  {
    key: 'remove_assigned_team',
    label: 'Remover equipe atribuída',
    inputType: null,
  },
  {
    key: 'send_email_transcript',
    label: 'Enviar transcrição por email',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'Silenciar conversa',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'Adiar conversa',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'Resolver conversa',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'Enviar Evento Webhook',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'Enviar anexo',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'Enviar mensagem',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'Adicionar nota privada',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'Alterar prioridade',
    inputType: 'search_select',
  },
];
